import { number, object, string, ValidationError } from 'yup'
import { KardexPeriodoInput } from '../../../base/interfaces'

export const KardexPeriodoIniciarValidator = async (
  input: KardexPeriodoInput,
): Promise<Array<string>> => {
  const schema = object({
    descripcion: string().required('Ingrese una descripción'),
    // codigoDocumentoSector: number().required('Seleccione un sector'),
  })
  try {
    await schema.validate(input, { abortEarly: false })
    return []
  } catch (error) {
    if (error instanceof ValidationError) {
      const errors: Array<string> = error.inner.map((err) => err.message)
      return errors
    } else {
      throw error
    }
  }
}

export const KardexPeriodoIniciarValidationSchema = object({
  descripcion: string().required('Ingrese una descripción'),
  // codigoDocumentoSector: number().required('Seleccione un sector'),
})
